import { ContragentViewModel } from '../../../../common/model/account/contragentViewModel';
import { createDataFetchSlice } from '../../../utils/dataFetch';


export const adminAccountContragentsDictionarySlice = createDataFetchSlice<
    Pick<ContragentViewModel, 'id' | 'name'>[]
>({ name: 'providersDictionary' });
